import { LogErrors } from './../../LogErrors'

import { GetZtudents as DLGetZtudents, ShowToZtudent as DLShowToZtudent, HideToZtudent as DLHideToZtudent, ResetZtudiantePassword as DLResetZtudiantePassword } from './../../DL/Instructor/Ztudents'


const GetZtudents = async () => {
    try {
        //Validar que exista la info del usuario en el session storage
        if (!sessionStorage.getItem('userData')) {
            return { success: false, message: '' } //En este caso borraron los datos; así que le muestro mensaje indicando que su sesión ha expirado.
        }
    
        //Obtener la info del usuario desde el session storage
        const userData = JSON.parse(sessionStorage.getItem('userData'))
    
        const token = userData?.token
        if (!token) {
            return { success: false, message: '' }
        }

        const idCenter = userData?.navigation?.center?.id
        if (!idCenter) {
            return { success: false, message: '' }
        }
        
        const response = await DLGetZtudents(idCenter, token)
        
        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        await LogErrors('GetZtudents - DL Ztudents', error)
    }
}

const HideToZtudent = async (ztudent, rows) => {
    try {
        //Validar que exista la info del usuario en el session storage
        if (!sessionStorage.getItem('userData')) {
            return { success: false, message: '' } //En este caso borraron los datos; así que le muestro mensaje indicando que su sesión ha expirado.
        }
    
        //Obtener la info del usuario desde el session storage
        const userData = JSON.parse(sessionStorage.getItem('userData'))
    
        const token = userData?.token
        if (!token) {
            return { success: false, message: '' }
        }

        const idZtudiante = ztudent?.idZtudiante
        if (!idZtudiante) {
            return { success: false, message: '' }
        }

        const idCenter = userData?.navigation?.center?.id
        if (!idCenter) {
            return { success: false, message: '' }
        }
        
        const response = await DLHideToZtudent(idZtudiante, idCenter, token)
        
        if (response.success) {
            const updatedRows = rows.map(z =>
                z.idZtudiante === ztudent.idZtudiante ? { ...z, isVisible: false } : z
            )

            return { success: true, data: updatedRows }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        console.error('Error en HideToZtudent:', error)
        return {
            success: false,
            message: `No ha sido posible ocultar al Ztudiante. Inténtalo nuevamente o más tarde.`,
        }
    }
}

const ShowToZtudent = async (ztudent, rows) => {
    try {
        //Validar que exista la info del usuario en el session storage
        if (!sessionStorage.getItem('userData')) {
            return { success: false, message: '' } //En este caso borraron los datos; así que le muestro mensaje indicando que su sesión ha expirado.
        }
    
        //Obtener la info del usuario desde el session storage
        const userData = JSON.parse(sessionStorage.getItem('userData'))
    
        const token = userData?.token
        if (!token) {
            return { success: false, message: '' }
        }

        const idZtudiante = ztudent?.idZtudiante
        if (!idZtudiante) {
            return { success: false, message: '' }
        }

        const idCenter = userData?.navigation?.center?.id
        if (!idCenter) {
            return { success: false, message: '' }
        }
        
        const response = await DLShowToZtudent(idZtudiante, idCenter, token)
        
        if (response.success) {
            const updatedRows = rows.map(z =>
                z.idZtudiante === ztudent.idZtudiante ? { ...z, isVisible: true } : z
            )

            return { success: true, data: updatedRows }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        console.error('Error en ShowToZtudent:', error)
        return {
            success: false,
            message: `No ha sido posible mostrar al Ztudiante. Inténtalo nuevamente o más tarde.`,
        }
    }
}

const ResetZtudiantePassword = async (ztudent) => {
    try {
        //Validar que exista la info del usuario en el session storage
        if (!sessionStorage.getItem('userData')) {
            return { success: false, message: '' } //En este caso borraron los datos; así que le muestro mensaje indicando que su sesión ha expirado.
        }
    
        //Obtener la info del usuario desde el session storage
        const userData = JSON.parse(sessionStorage.getItem('userData'))
    
        const token = userData?.token
        if (!token) {
            return { success: false, message: '' }
        }

        const idZtudiante = ztudent?.idZtudiante
        if (!idZtudiante) {
            return { success: false, message: '' }
        }

        const idCenter = userData?.navigation?.center?.id
        if (!idCenter) {
            return { success: false, message: '' }
        }
        
        const user = ztudent?.user
        if (!user) {
            return { success: false, message: '' }
        }
        
        const response = await DLResetZtudiantePassword(idCenter, idZtudiante, user, token)
        
        if (response.success) {
            return { success: true, data: null }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        console.error('Error en ResetZtudiantePassword:', error)
        return {
            success: false,
            message: `No ha sido posible mostrar al Ztudiante. Inténtalo nuevamente o más tarde.`,
        }
    }
}

export { GetZtudents, HideToZtudent, ShowToZtudent, ResetZtudiantePassword };